// Contractor roles per the signed V1 charter. Keep in sync with backend/roles.py.
export const CONTRACTOR_ROLES = [
  { value: "company_admin", label: "Company Admin" },
  { value: "project_manager", label: "Project Manager" },
  { value: "purchaser", label: "Purchaser" },
  { value: "approver", label: "Approver" },
  { value: "accounting", label: "Accounting" },
  { value: "field_user", label: "Field User" },
];

export const ROLE_LABELS = Object.fromEntries(CONTRACTOR_ROLES.map((r) => [r.value, r.label]));

export const roleLabel = (value) => ROLE_LABELS[value] || (value || "").replace(/_/g, " ");

// Roles that may act on any pending approval step as fallback reviewers.
export const FALLBACK_APPROVER_ROLES = ["company_admin", "approver"];

// Company-administration screens are restricted to this role.
export const ADMIN_ROLE = "company_admin";

// Roles allowed to originate/act on purchasing activity — keep in sync with
// backend/roles.py's PURCHASING_ROLES.
export const PURCHASING_ROLES = ["company_admin", "purchaser", "project_manager"];

// Roles allowed to record a delivery receipt on a PO — keep in sync with
// backend/roles.py's RECEIVING_ROLES.
export const RECEIVING_ROLES = ["field_user", "purchaser", "project_manager", "company_admin"];

// Roles allowed to log an outside (off-platform) purchase — keep in sync
// with backend/roles.py's OUTSIDE_PURCHASE_ROLES.
export const OUTSIDE_PURCHASE_ROLES = ["purchaser", "project_manager", "field_user", "accounting", "company_admin"];

// Roles allowed to manage card-platform integrations and reconcile imported
// transactions — keep in sync with backend/roles.py's CARD_IMPORT_ROLES.
export const CARD_IMPORT_ROLES = ["accounting", "company_admin"];

// Roles that may code a Ramp charge (category + job, memo, receipt) — admins
// and accounting for any charge, a purchaser for their own. Keep in sync with
// backend/routers/contractor.py's card_code_dep.
export const CARD_CODE_ROLES = ["accounting", "company_admin", "purchaser"];

// Staff portal roles + privileges. Keep in sync with backend/roles.py's
// STAFF_ROLES / STAFF_ROLE_LABELS / STAFF_PRIVILEGES.
export const STAFF_ADMIN_ROLE = "staff_admin";
export const STAFF_ROLES = [
  {
    value: "staff_admin", label: "Platform Admin", description: "Every area, plus managing the staff team.",
    tip: "Full access to the staff portal, and the only role that can invite staff, change roles and privileges, or deactivate accounts.",
  },
  {
    value: "staff_member", label: "Staff", description: "Only the areas ticked below.",
    tip: "Sees the dashboard plus only the areas a Platform Admin ticks. Can't manage the staff team.",
  },
];
export const STAFF_PRIVILEGES = [
  { value: "onboarding", label: "Onboarding Queue", description: "Approve or decline vendor and contractor signups" },
  { value: "vendor_leads", label: "Vendor Leads", description: "Work the out-of-network vendor pipeline" },
  { value: "directories", label: "Directories", description: "Vendor and contractor directories, vendor catalog imports" },
  { value: "transactions", label: "Transaction Monitor", description: "Platform-wide transactions and integration health" },
];
export const staffRoleLabel = (value) => STAFF_ROLES.find((r) => r.value === value)?.label || value;
export const staffCan = (user, privilege) => user?.role === STAFF_ADMIN_ROLE || (user?.privileges || []).includes(privilege);
